import ProductInfoCollapse from './ProductInfoCollapse.jsx';

export {
  ProductInfoCollapse
}


// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/product-info-collapse/index.js